// 弹窗模板枚举
export enum PublicModalId {
  DEFAULT,
  UserFirstUpgradePlan
}
